import './Loading.scss';
import { memo } from 'react';
import { IconWrapper } from 'src/modules/common/icons/IconWrapper';

export const Loading = memo(() => (
    <div className="vss-custom-loading">
        <IconWrapper>
            <svg
                viewBox="0 0 24 24"
                fill="none"
            >
                <circle
                    fill="none"
                    stroke="currentColor"
                    cx="50%"
                    cy="50%"
                    r="10"
                />
            </svg>
        </IconWrapper>
    </div>
));
